import React from 'react';

import {
  ContractTypeFilterValue,
  ContractTypeValue,
  ContractTypeFilterCount,
} from 'ha/types/SearchFilters';
import { useIntl } from 'ha/i18n';

import CommonCheckboxFilter from './CommonCheckboxFilter';
import CommonCheckboxTitleWithCount from './CommonCheckboxTitleWithCount';

interface Props {
  value: ContractTypeFilterValue;
  onChange: (value: ContractTypeFilterValue) => void;
  count?: ContractTypeFilterCount;
}

const ContractTypeFilter: React.FC<Props> = ({ value, onChange, count }) => {
  const { T } = useIntl();

  return (
    <CommonCheckboxFilter
      options={[
        {
          value: ContractTypeValue.Daily,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('rental_contract.daily')}
              count={count?.daily}
            />
          ),
          testLocator: 'Filter Daily',
        },
        {
          value: ContractTypeValue.Fortnightly,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('rental_contract.fortnightly')}
              count={count?.fortnightly}
            />
          ),
          testLocator: 'Filter Fortnightly',
        },
        {
          value: ContractTypeValue.Monthly,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('rental_contract.monthly')}
              count={count?.monthly}
            />
          ),
          testLocator: 'Filter Monthly',
        },
      ]}
      value={value}
      onChange={onChange}
    />
  );
};

export default ContractTypeFilter;
